<template>
  <div class="tutorial-centered">
    <div>
      <div
        v-if="content.image"
        class="tutorial-centered__img"
      >
        <img
          :src="content.image"
          alt="arrow"
        >
      </div>
      <h1>{{ content.title }}</h1>
      <div class="description-container">
        <p v-if="content.description">
          {{ content.description }}
        </p>
        <ul v-else-if="content.topics">
          <li
            v-for="(topic, rowIndex) in content.topics"
            :key="rowIndex"
            :class="topic.color + '-color'"
          >
            {{ topic.label }}
          </li>
        </ul>
        <tutorial-button
          :action="action"
          :content="content.cta"
        />
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './tutorialMixin'

export default {
  name: 'TutorialCentered',
  mixins: [mixin]
}
</script>

<style lang="scss">
  .tutorial-centered {
    text-align: center;
    z-index: 9004;
    position: fixed;
    width: 100%;
    height: calc(100% - 12vh);
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &__img {
      margin-bottom: 30px;
    }

    .description-container {
      width: 48%;
      min-width: 480px;
      margin: 0 auto;

      .footer {
        margin-top: 20px;
      }

      .tutorial-button {
        justify-content: center;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 13vh;
      }
    }
  }
</style>
